export const getQueryKey = (listingId: string) => ['listingOrders', listingId];
